import { connect } from 'react-redux'
import ProductInfo from '../../../components/products/details/product/edit/pane/ProductInfo'
import * as actions from '../../../state/actions/provider-products/index'
import { IStoreState, IProviderProductObject } from '../../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    product: ownProps.product,
    serviceLevels: ownProps.serviceLevels
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    saveProduct: (product: IProviderProductObject) => {
      return dispatch(actions.saveProduct(product))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductInfo)



// WEBPACK FOOTER //
// ./src/containers/products/productedit/ProductInfo.ts